import { render } from "./PropheticNewsTab.vue?vue&type=template&id=f99d0c98&scoped=true"
import script from "./PropheticNewsTab.vue?vue&type=script&lang=js"
export * from "./PropheticNewsTab.vue?vue&type=script&lang=js"

import "./PropheticNewsTab.vue?vue&type=style&index=0&id=f99d0c98&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f99d0c98"]])

export default __exports__